export default "__VITE_ASSET__B3cf4pml__"